<template>
  <div id="contenedor-main-contrato">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'MainContrato',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
